import { useTutorReviewStats } from 'hooks/useTutorReviews';

import classes from './TutorReviewsSection.module.scss';

type TutorReviewsSummaryProps = {
  tutorUserId?: number;
  publicAccess?: boolean;
  className?: string;
};

export const TutorReviewsSummary = ({
  tutorUserId,
  publicAccess = false,
  className,
}: TutorReviewsSummaryProps) => {
  const { data: stats } = useTutorReviewStats(tutorUserId, publicAccess);

  if (!tutorUserId) {
    return null;
  }

  const total = stats?.total_reviews ?? 0;

  const scrollToReviews = () => {
    document.getElementById('tutor-reviews')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <button
      type='button'
      className={`${classes.compact}${className ? ` ${className}` : ''}`}
      onClick={scrollToReviews}
    >
      <span>{total === 0 ? 'Нет отзывов' : `${total} ${total === 1 ? 'отзыв' : 'отзывов'}`}</span>
    </button>
  );
};
